import { render, staticRenderFns } from "./OrdersDocumentsTable.vue?vue&type=template&id=b3085704&scoped=true"
import script from "./OrdersDocumentsTable.vue?vue&type=script&lang=js"
export * from "./OrdersDocumentsTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersDocumentsTable.vue?vue&type=style&index=0&id=b3085704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3085704",
  null
  
)

export default component.exports